import * as React from 'react';
import {connect} from 'react-redux';

class SimpleInputAgGridRenderer extends React.Component{

  render(){
    const {projectsErrors,data,column} = this.props;
    return(
      <div style={{position: 'relative'}}>
        <p>{this.props.value}</p>
        <p style={{
          position: 'absolute',
          top: '0',
          left: '-10px',
          color: 'red'
        }}>
          {projectsErrors[data.projectIndex] && projectsErrors[data.projectIndex][column.colId] && projectsErrors[data.projectIndex][column.colId]}
        </p>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    projectsErrors: state.projects.projectsErrors,
  }
};
export default connect(mapStateToProps)(SimpleInputAgGridRenderer);


// WEBPACK FOOTER //
// ./src/views/Projects/Projects/FieldRenderer/SimpleInputAgGridRenderer.js